// extracted by mini-css-extract-plugin
export default {"selectTable":"mappingSelect_selectTable__dyKzw","borderLeft":"mappingSelect_borderLeft__b61pf","divBox":"mappingSelect_divBox__8kFsE"};